import Image from "next/image";
import { HTMLAttributes } from "react";

export default function NextAuth(props: HTMLAttributes<HTMLImageElement>) {
  return (
    <Image {...props} src="/images/stacks/next-auth.png" alt="NextAuth" width={48} height={48} quality={100} loading="lazy" decoding="async" />
  )
}
